<script>
    import ButtonDefault from "../controls/ButtonDefault.svelte";

    export let title = "Message";
    export let message = "This is a message.";
    export let onClose = () => {};
    let show = true;
  
    function closeModal() {
      show = false;
      onClose();
    }
</script>

{#if show}
  <div class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
    <div class="bg-gray-800 text-gray-200 rounded-lg shadow-lg p-6 w-1/3">
      <h2 class="text-lg font-bold mb-4 text-white">{title}</h2>
      <p class="mb-6">{message}</p>
      <div class="flex justify-end">
        <ButtonDefault
        onClick={closeModal}
        text="OK"
        />
      </div>
    </div>
  </div>
{/if}